import React from 'react';

const WrapWithLayout = (Comp, Layout, props) => {
  if (Layout) {
    return <Layout><Comp {...props} /></Layout>
  }
  return <Comp {...props} />
}

export default WrapWithLayout;